export default __webpack_public_path__ + "static/media/BL.ee590c64.ico";